var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.9338C0 0.418076 0.360794 0 0.805857 0H15.1941C15.6392 0 16 0.418076 16 0.9338C16 1.44952 15.6392 1.8676 15.1941 1.8676H0.805855C0.360793 1.8676 0 1.44952 0 0.9338Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.00031C0 5.48459 0.360794 5.06651 0.805857 5.06651H9.84618C10.2912 5.06651 10.652 5.48459 10.652 6.00031C10.652 6.51604 10.2912 6.93411 9.84618 6.93411H0.805857C0.360794 6.93411 0 6.51604 0 6.00031Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.805857 10.1324C0.360794 10.1324 0 10.5505 0 11.0662C0 11.5819 0.360793 12 0.805855 12H4.49823C4.94329 12 5.30408 11.5819 5.30408 11.0662C5.30408 10.5505 4.94329 10.1324 4.49823 10.1324H0.805857Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGrey);
export default __webpack_public_path__ + "static/media/filterGrey.607e051db1d93c31391f76ed7028f1e8.svg";
export { ForwardRef as ReactComponent };